import React from "react";
import { Link } from "react-router-dom";
import MenuNav from "../../components/portfolio/menu-nav.component";
import "./notfound.styles.css";

const NotFound = () => (
  <div className="page-wrapper notfound-page">
    <MenuNav />
    <section className="notfound-section">
      <h1 className="h1">404</h1>
      <p className="h3">Oops! The page you are looking for does not exist.</p>
      <Link to="/" className="button">
        <div className="h4 y">Go home</div>
      </Link>
    </section>
  </div>
);

export default NotFound;
